import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { analyticActionMap } from '../../analytics/utils';
import { fireMessageEvent } from '../../messenger/utils';

const ToggleButton = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.3);
  width: 100%;
  height: 100%;
  min-height: ${({ theme }) => theme.spacings.peta};
  background-color: ${({ theme }) => theme.colors.headerBg};
  padding: ${({ theme }) => theme.spacings.bit};
  ${({ isSelected, theme }) => isSelected && `background-color: ${theme.colors.white}`}
`;
const ButtonList = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  width: 100%;
`;

const ButtonListItem = styled.li`
  display: inline-block;
  width: 33.33%;
  :first-of-type {
    button {
      border-radius: 4px 0 0 4px;
    }
  }
  :last-child {
    button {
      border-radius: 0 4px 4px 0;
    }
  }
`;

const Label = styled.label`
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.typography.text.giga.fontSize};
  line-height: ${({ theme }) => theme.typography.text.giga.lineHeight};
  white-space: pre-line;
  ${({ isSelected, theme }) => isSelected && `color: ${theme.colors.black}`}
`;

const { clickedType, path, tabType } = analyticActionMap;

const ToggleViewButton = ({ options, handleViewToggle, currentView }) => {
  const { env, platform } = useSelector((state) => state.config);

  const HandleViewChange = (key) => {
    fireMessageEvent({
      platform,
      env,
      title: clickedType,
      data: {
        path: path,
        element: tabType,
        element_name: `leaderboard_${key}`,
      },
    });

    handleViewToggle(key);
  };

  return (
    <ButtonList>
      {options.map((option) => {
        return (
          <ButtonListItem key={option.key}>
            <ToggleButton onClick={() => HandleViewChange(option.key)} isSelected={currentView === option.key}>
              <Label isSelected={currentView === option.key}>{option.value}</Label>
            </ToggleButton>
          </ButtonListItem>
        );
      })}
    </ButtonList>
  );
};

ToggleViewButton.propTypes = {
  options: PropTypes.arrayOf(PropTypes.exact({ key: PropTypes.string, value: PropTypes.string })),
  handleViewToggle: PropTypes.func,
  currentView: PropTypes.string,
};

export default ToggleViewButton;
